module.exports = __webpack_public_path__ + "img/142.04cf7c74.png";